<template>
<div>
    <div>
        <li class="item list-group-item p-0 m-0 file-item">
            <div class="d-flex justify-content-between" @click="toggle" @dblclick="makeFolder">
              <div >
                <!-- <span v-if="isFolder" class="pr-1">[{{ isOpen ? '-' : '+' }}]</span> -->
                <span class="pr-1 ">
                  <span v-if="isFolder" >
                    <i v-if="isOpen" class="img-icon img-icon-folder-open-sm align-baseline"></i>
                    <i v-else class="img-icon img-icon-folder-closed-sm-filled align-baseline"></i>
                  </span>
                  <span v-else >
                    <i class="img-icon img-icon-file-sm align-baseline"></i>
                  </span>
                </span>
                <span>
                  <h5 class="d-inline">{{ item.name }}</h5>
                </span>
              </div>
              <div>
                <span>
                  <!-- <b-badge variant="primary" pill class="pb-1">14</b-badge>
                  <b-badge variant="secondary" pill class="pb-1">2</b-badge>
                  <b-badge variant="success" pill class="pb-1">7</b-badge> -->
                </span>
              </div>
            </div>
            <ul v-if="isFolder" v-show="isOpen">
              <tree-item
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                @select-item="$emit('select-item', $event)"
                @add-item="$emit('add-item', $event)"
              ></tree-item>
              <!-- <li class="add" @click="$emit('add-item', item)">+</li> -->
            </ul>
        </li>
    </div>
</div>
</template>

<script>
export default {
  name: 'tree-item', // we need to define the name since this component is recursive
  props: {
    item: Object,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isFolder() {
      return this.item.isDir && this.item.children;
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
      this.$emit('select-item', this.item);
    },
    makeFolder() {
      if (!this.isFolder) {
        this.$emit('make-folder', this.item);
        this.isOpen = true;
      }
    },
  },
};
</script>

<style scoped>
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>
